/* eslint-disable eslint-comments/disable-enable-pair, security/detect-object-injection */
import mapSearchParamsToQueryObject from 'src/utils/mapSearchParamsToQueryObject';
import filtersShortNames from 'src/consts/filtersShortNames.json';

const flattenAndFilterSearchParams = (searchParams) => {
  const searchQuery = mapSearchParamsToQueryObject({
    ...searchParams,
    radius: !searchParams.radiusDisabled ? searchParams.radius : ''
  });

  return Object.keys(searchQuery)
    .filter(criteriaName => searchQuery[criteriaName] !== '')
    .filter(criteriaName => !(Array.isArray(searchQuery[criteriaName]) && !searchQuery[criteriaName].length))
    .reduce((params, criteriaName) => {
      if (Array.isArray(searchQuery[criteriaName])) {
        return {
          ...params,
          [criteriaName]: searchQuery[criteriaName].join(',')
        };
      }
      if (searchQuery[criteriaName] !== '') {
        return {
          ...params,
          [criteriaName]: String(searchQuery[criteriaName])
        };
      }
      return params;
    }, {
      [filtersShortNames.pageNumber]: '1',
      [filtersShortNames.rowOnPage]: '50'
    });
};

const extractQuery = ({ tokens = [], value = '' }) => {
  const query = tokens.map(token => token.text || token.label);
  return (value.replace(' ', '').length > 0 ? [...query, value] : query).join(',');
};

const buildSearchParamsForAnalytics = (searchParams = {}) => {
  const { keyword, workplace } = searchParams.autocomplete;
  const allSearchCriteria = flattenAndFilterSearchParams(searchParams.current);

  const query = {
    [filtersShortNames.keyword]: extractQuery(keyword),
    [filtersShortNames.workplace]: extractQuery(workplace)
  };

  const searchCriteria = Object.keys(allSearchCriteria)
    .filter(criteriaName => ![
      filtersShortNames.pageNumber, filtersShortNames.rowOnPage
    ].includes(criteriaName))
    .reduce((params, parameterName) => ({
      ...params,
      [parameterName]: allSearchCriteria[parameterName]
    }), {});

  return {
    query,
    searchCriteria
  };
};

const trackerNameSpace = 'gptr';

function sendTrackerEvent(...arguments_) {
  window[trackerNameSpace]('send', ...arguments_);
}


const sendSearchClick = (searchParams) => {
  const data = buildSearchParamsForAnalytics(searchParams);
  sendTrackerEvent('searchclick', data);
};

export {
  sendSearchClick
};

export default {
  sendSearchClick
};
